// extracted by mini-css-extract-plugin
export const arrow = "ChartTooltip__arrow__M4ulG";
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const chartTooltip = "ChartTooltip__chartTooltip__K6yXX";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";